// lib/i18n.ts
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from '../locales/en.json';
import fr from '../locales/fr.json';
import zh from '../locales/zh.json';

// Language configuration
const resources = {
  en: { translation: en },
  fr: { translation: fr },
  zh: { translation: zh },
};

// Get stored language or detect from browser
function getInitialLanguage(): string {
  // Check localStorage first
  const stored = localStorage.getItem('language');
  if (stored && ['en', 'fr', 'zh'].includes(stored)) {
    return stored;
  }

  // Detect from browser
  const browserLang = navigator.language.split('-')[0];
  if (['en', 'fr', 'zh'].includes(browserLang)) {
    return browserLang;
  }

  return 'en';
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getInitialLanguage(),
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React already handles escaping
    },
  });

// Save language preference
export function setLanguage(lang: string): void {
  localStorage.setItem('language', lang);
  i18n.changeLanguage(lang);
}

// Get current language
export function getLanguage(): string {
  return i18n.language;
}

// Available languages for the language switcher
export const languages = [
  { code: 'en', name: 'English', flag: '🇨🇦' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'zh', name: '中文', flag: '🇨🇳' },
];

export default i18n;
